export const ExportOptions = [
    { id: 1, name: 'Current' },
    {
      id: 2, name: 'All'
    }
  ];
